import { PaymentCardBrand } from "@app/postBill/models";

export type PaymentMethodSummaryObject = {
  brand: PaymentCardBrand;
  last4digits: string;
  expiry: string;
};

export function parsePaymentMethodSummary(
  paymentMethodSummary: string | undefined
): PaymentMethodSummaryObject | undefined {
  if (!paymentMethodSummary || paymentMethodSummary === "null") {
    return undefined;
  }
  const parts = paymentMethodSummary.split("/");
  const digitSplit = parts[1].split("-");
  return {
    brand: parts[0] as PaymentCardBrand,
    last4digits: digitSplit[0],
    expiry: digitSplit[1] + "/" + parts[2],
  };
}
